import React, { useEffect } from 'react'
import styled from 'styled-components'
import api from '../../api'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import RichText from '../../components/RichText'

const Privacy = () => {
  //
  const { data: webDocuments, isLoading: isWebDocumentsLoading } = api.useGetWebPageQuery('privacy')
  //
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
    //
    return () => {}
  }, [])
  //
  //
  return isWebDocumentsLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Container>
        <Content>
          <RichText html={webDocuments?.body || ''} />
        </Content>
      </Container>
    </Wrapper>
  )
}
//
const Content = styled.div`
  padding-block: 50px;
`
const Wrapper = styled.div``
//
export default Privacy
